import { NewNames as NewNamesForm } from '@bgea-js/form-templates';
import customModalHeaderClimb from "../../../../src/content/climb-signup-and-watch-page/customModalHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  customModalHeaderClimb,
  React
};